import React, { useState, useContext, useCallback, useEffect, useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';
import './MyInvestments.css';
import { CsrfTokenContext } from '../CsrfTokenContext'; // Assuming you have this context set up
import DecisionModal from './DecisionModal';
// import { setSelectedSymbol } from '../pages/slices/simulationEntriesSlicer';
import { isTokenExpired, handleLogin } from '../pages/utils/AuthenticationHelper';
import TextBaloon from './TextBaloon'; 
import DataPicker from './DataPicker';
import ChartROIBar from './ChartROIBar';
import BecomePremiumInvite from './BecomePremiumInvite';
// import Select from 'react-select';
import CustomSelect from './CustomSelect';
// import _ from 'lodash';

const MyInvestments = () => {
  const [status, setStatus] = useState(null);
  const [investments, setInvestments] = useState([]);  
  const [selectedSymbol, setSelectedSymbol] = useState([]);
  const [date, setDate] = useState('');  
  const [buyValue, setBuyValue] = useState('');  
  const [investmentAmmount, setInvestmentAmmount] = useState('');  
  const [snapshotPrice, setSnapshotPrice] = useState([]);  
  const [totalAmount, setTotalAmount] = useState(0);  
  const [totalCurrentReturn, setTotalCurrentReturn] = useState(0);
  const [totalCurrentProfit, setTotalCurrentProfit] = useState(0);
  const [totalROI, setTotalROI] = useState(0);
  // const [originalStrategies, setOriginalStrategies] = useState([]);  

  // document.querySelector('.inves_button_open').textContent = "Close";
  
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);  
  const [canDelete, setCanDelete] = useState(false);  
  const [selectedFollowId, setSelectedFollowId] = useState(0);  
  const [modalShow, setModalShow] = useState(false);
  const [statusModalShow, setStatusModalShow] = useState(false);
  const [actionStatus, setActionStatus] = useState(false);        
  const [spin, setSpin] = useState(false);        
  const [selectedInvestment, setSelectedInvestment] = useState({});  
  const [reachedLimit, setReachedLimit] = useState(false);  

  const { walletId, isPremium } = useSelector(state => state.globalData);
  const { symbolIcons } = useSelector(state => state.streamCryptoInfo);
  const { prices } = useSelector(state => state.streamCryptoInfo);  

  const handleShow = () => setModalShow(true);
  const handleStatusShow = () => setStatusModalShow(true);

  const handleClose = () => {
    setModalShow(false);
    setStatusModalShow(false);
    setSelectedFollowId(0);
    setCanDelete(false);
  };

  const handleBuyValueChange = (event) => {
    setBuyValue(event.target.value);
  };

  const handleInvestmentAmmountChange = (event) => {
    setInvestmentAmmount(event.target.value);
  };

  const csrfToken = useContext(CsrfTokenContext); 
  
  const refreshTokenIfNeeded = useCallback(async () => {
    if (isTokenExpired()) {        
      await handleLogin();
    }    
  },[]);


  useEffect(() => {
    if (prices && investments) {
      const updatedPrices = investments.map((investment) => {
        const symbolKey = `${investment.symbol.replace('-', '')}T`;
        const symbolPrice = prices[symbolKey] || 0; // Default to 0 if not found
        return { symbol: investment.symbol, price: parseFloat(symbolPrice).toFixed(7) };
      });
  
      // Compare and update only if necessary
      setSnapshotPrice((prevPrices) => {
        const isSame = JSON.stringify(prevPrices) === JSON.stringify(updatedPrices);
        return isSame ? prevPrices : updatedPrices;
      });
    }
    
  }, [prices, investments]);


  useEffect(() => {
    if (selectedSymbol && date && buyValue && investmentAmmount) {
      setIsButtonDisabled(false);
    } else {
      setIsButtonDisabled(true);
    }
  }, [selectedSymbol, date, buyValue, investmentAmmount]);

  const get_Investments = useCallback(async () => {        
    try {

        setReachedLimit(false);

        await refreshTokenIfNeeded();        
                                    
        const strFetch = `/api/get_investments?walletId=${walletId}`;
        
        const response = await fetch(strFetch, {
            method: 'GET',
            headers: {                    
                'Content-Type': 'application/json',
                'X-CSRFToken': csrfToken
            }
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error);
        }

        const result = await response.json();
        const invests = isPremium ? result : result.slice(0, 3);
        setInvestments(invests);      

        const totalAmt = (result || []).reduce((sum, item) => {
          return Number(sum) + Number(item.ammount);
        }, 0);

        setTotalAmount(totalAmt);
        
    } catch (err) {       
        console.error('Error plotting data:', err);        
    }        
  },[csrfToken, refreshTokenIfNeeded, walletId, isPremium]);  

  useEffect(()=>{
    
    get_Investments();

  },[get_Investments]);
  
  
  const saveInvestment = async () => {
    try {  
      
        if(!isPremium && investments.length >= 3){
          setReachedLimit(true);
          return;
        }
      
        const investment_set = {symbolSet : selectedSymbol, date : date, buyValue : buyValue, ammount : investmentAmmount}
                
        await refreshTokenIfNeeded();
                      
        const response = await fetch(`/api/set_investment`, {
            method: 'POST',
            // credentials: 'include',
            headers: {              
            'Content-Type': 'application/json',
            'X-CSRFToken': csrfToken, // Ensure the CSRF token is correctly passed
            },
            body: JSON.stringify({walletId : walletId, investment_set : investment_set})
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.error);
        }
        setStatus('Saved!');

        get_Investments();

        // getAllFollowStrategies();       
  
    } catch (err) {
      console.error('Error fetching data:', err);     
    }
  };

  const closeOperation = async () => {
    try {

        setActionStatus(false);
        
        await refreshTokenIfNeeded();
                      
        const response = await fetch(`/api/close_investment`, {
            method: 'POST',
            // credentials: 'include',
            headers: {              
            'Content-Type': 'application/json',
            'X-CSRFToken': csrfToken, // Ensure the CSRF token is correctly passed
            },
            body: JSON.stringify({invest_id : selectedFollowId, close_value : selectedInvestment?.symbolPrice || 0.0})
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.error);
        }

        setActionStatus(true);
                        
        setTimeout(() => {
          setSpin(false);
          setActionStatus(false);          
          get_Investments();          
          setSelectedInvestment({});
          handleClose();
      }, 1000);

        // getAllFollowStrategies();       
  
    } catch (err) {
      console.error('Error fetching data:', err);  
      handleClose();   
    }
  };  


  // const del_strategy = async (wallet, followId) => {
  const del_investment = async (wallet, followId) => {
    try {
      await refreshTokenIfNeeded();
        setActionStatus(false);
        setSpin(true);
        
        const response = await fetch(`/api/del_investment`, {
            method: 'DELETE',
            // credentials: 'include',
            headers: {            
                'Content-Type': 'application/json',
                'X-CSRFToken': csrfToken // Ensure csrfToken is correctly set
            },
            body: JSON.stringify({
              invest_id : selectedFollowId
            })
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error);
        }

        setActionStatus(true);

        setTimeout(() => {
            setSpin(false);
            get_Investments();
            setModalShow(false);
            setActionStatus(false);
            setTotalROI(0);
            setStatus('Investment has been deleted!');            
        }, 1000);

    } catch (err) {
        console.error('Error deleting Investment:', err);
        setModalShow(false);
        setActionStatus(false);        
    }
  };

  const saveChanges = () => {  
    saveInvestment();
    setSelectedSymbol([]);
    setDate('');  
    setBuyValue(''); 
    setInvestmentAmmount(''); 
  };

  const deleteStrategy = () =>{
    del_investment(walletId, selectedFollowId);
  } 

  const handleSelectedRow = (index, investment) => {

    setSelectedFollowId(index);    
    setSelectedInvestment(investment);
    setCanDelete(true);
    setStatus('');

  };

  const handleCloseOperation = (investment) => {
    setSelectedFollowId(investment.invest_id);
    setSelectedInvestment(investment);    
    handleStatusShow();
    // upd_status(index);
  };

  const cellStyle = {
    textAlign: 'center',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  };
  
  const handleChange = (selectedOption) => {       
    const symbolSel = {'value':selectedOption.value, 'symbol_icon': selectedOption.symbol_icon, 'ranking':selectedOption.ranking};    
    setSelectedSymbol(symbolSel);
    setDate(new Date().toDateString());

    const symbolKey = `${symbolSel.value.replace('-', '')}T`;
    const symbolPrice = prices[symbolKey] || 0;
    const price = parseFloat(symbolPrice).toFixed(7);
    setBuyValue(price);
  };

  const handleDateChange = (date) => {          
    setDate(date.toDateString());     
  };


  function calculatePercentage(price1, price2) {
    if (!price1 || !price2) return "0.00"; // Handle cases where values are missing
    return (((price2 - price1) / price1) * 100).toFixed(2);
  }

  const formattedDatesCache = useRef({}); // Cache for storing already formatted dates

  const enhancedInvestments = useMemo(() => {
    
    const formatDate = (stringDate) => {
      const key = stringDate || 'today'; // Use date string or 'today' as the cache key
      if (!formattedDatesCache.current[key]) {        
        let formattedDate;
        if (!stringDate) {
          formattedDate = new Date().toISOString().split('T')[0]; // Format current date
        } else {
          const parsedDate = new Date(stringDate);
          if (isNaN(parsedDate)) {
            console.error('Invalid date string:', stringDate);
            return 'Invalid Date'; // Handle invalid date gracefully
          }
          formattedDate = parsedDate.toISOString().split('T')[0]; // Format valid date
        }
        formattedDatesCache.current[key] = formattedDate;
      }
      return formattedDatesCache.current[key];
    };

    const getPriceBySymbol = (symbol) => {
      const snapshot = snapshotPrice.find((item) => item.symbol === symbol);
      return snapshot ? snapshot.price : null; // Return price if found, otherwise null
    };

    function formatNumberSmart(num) {      
      if (!num) return 0.0;

      const vlr = parseFloat(num);
      // const integerPart = Math.floor(Math.abs(vlr)); // Get the integer part
      // return integerPart === 0 ? vlr.toFixed(7) : vlr.toFixed(2);
      return vlr < 0.01 ? vlr.toFixed(7) : vlr.toFixed(2);
    }
    
    let totalCurrentReturn = 0;
    let totalCurrentProfit = 0;

    const updatedInvestments = investments.map((investment) => {
      // const price = getPriceBySymbol(investment.symbol);      
      const symbolPrice = formatNumberSmart(getPriceBySymbol(investment.symbol)); // Retrieve price from snapshot state
      const closeValue = investment.isOpen ? symbolPrice : investment.invest_close_value;
      const roi = calculatePercentage(investment.invest_value, closeValue); 
      const symbolIcon = symbolIcons[investment.symbol.replace('-', '') + 'T'];
      
      const returnCurrentTotalAmount = investment.ammount + (investment.ammount * roi / 100);            
      totalCurrentReturn += returnCurrentTotalAmount;      

      const returnAmtProfit = (investment.ammount * roi / 100);            
      totalCurrentProfit += returnAmtProfit;      

      return {
        ...investment,
        symbolPrice,
        roi,
        isPositive: roi > 0,
        close_date: investment.isOpen ? formatDate() : formatDate(investment.invest_close_date),
        close_value: closeValue,
        dateInvest: formatDate(investment.invest_date),
        returnAmtProfit:returnAmtProfit.toFixed(2),
        symbolIcon:symbolIcon
      };
    });

    // setTotalReturn(totalReturn.toFixed(2));
    setTotalCurrentReturn(totalCurrentReturn.toFixed(2));
    setTotalCurrentProfit(totalCurrentProfit.toFixed(2));
    
    if (totalCurrentReturn > 0) { // Ensure totalAmount is valid to avoid division by zero
      const totalROI = ((totalCurrentReturn - totalAmount) / totalAmount) * 100;
      setTotalROI(totalROI.toFixed(2)); // Update total ROI state
    }

    return updatedInvestments;

  }, [investments, snapshotPrice, totalAmount, symbolIcons]); // Ensure dependencies are included

  return (
    <>      
        <div className="contentWrapper" style={{ display: 'flex', flexDirection: 'column', minHeight: '100%', width:'100%', alignItems:'center' }}>
        <br/>
        <TextBaloon textColor='#d2d2d2' text={<> It’s a free space to track your investments! Just fill it in, and it will show you real-time updates on your progress. If you decide to stop tracking, you can close it to keep the history or simply delete it.          
          </>} color='#387238' />
          <br/>          
          <br/> 
          <div style={{fontSize:'15pt', color:'#ff8200'}}>
            {walletId===0 &&
              <p>Wallet not connected! Please connect your wallet to continue.</p>
            }
          </div>         
          <div style={{ display:'flex' }} >
            {/* <div style={{borderRadius:'10px', border:'1px solid grey', display:'flex', flexDirection:'column', alignItems:'center', paddingBottom: '20px' }} > */}
            <div style={{display:'flex', flexDirection:'column', alignItems:'center', paddingBottom: '20px' }} >            
              <div className={`grid-container ${walletId===0 ? 'disable_input_control' : ''}`}>
                <span>Symbol</span>           
                  <CustomSelect handleChange={handleChange} selectedOption={selectedSymbol}/>
                <span>Buy Date</span>
                  <DataPicker onDateChange={handleDateChange} selectedDate={date !== '' ? new Date(date) : null} />
                <span>Buy Price</span>
                  <input className='buy-value' step={.01} type='number' placeholder='Enter the buy value' value={buyValue} onChange={handleBuyValueChange}></input>
                <span>Amount</span>
                  <input className='buy-value' step={.01} type='number' placeholder='Enter amount invested' value={investmentAmmount} onChange={handleInvestmentAmmountChange}></input>
              </div>
              <div className={`button_container_fw button_save ${isButtonDisabled ? 'disable_button_follow' : ''}`}
                  onClick={!isButtonDisabled ? saveChanges : undefined} >
                  <i className="bi bi-save-fill" style={{ marginRight: '5px' }}></i>
                  Save Investment
              </div>            
            </div>
            {/* <div style={{borderRadius:'10px', border:'1px solid grey', display:'flex', flexDirection:'column', alignItems:'center', paddingBottom: '20px' }} > */}
            <div>
              <div className="grid-container-dashboard">
                <span>Total Initial Amount</span>           
                <span>${totalAmount.toFixed(2)}</span>

                <span>Total Current Amount</span>
                <span style={{color:`${totalCurrentReturn > totalAmount ? '#72f272' : '#f29a9a'}`}}>${totalCurrentReturn}</span>

                <span>Total Return</span>
                <span style={{color:`${totalCurrentReturn > totalAmount ? '#72f272' : '#f29a9a'}`}}>${totalCurrentProfit}</span>

                <span>Total ROI</span>
                <span style={{color:`${totalCurrentReturn > totalAmount ? '#72f272' : '#f29a9a'}`}}>{totalROI}%</span>
              </div>
              {enhancedInvestments && enhancedInvestments.length > 0 &&
                <ChartROIBar data={enhancedInvestments} />               
              }        
            </div>
          </div>
        <br/>
        <br/>
          {reachedLimit &&
            <div style={{marginBottom:'30px'}}>              
              <BecomePremiumInvite message={"You’ve reached the limit of 3 investment registrations."}/>
            </div>            
          }
          <div style={{fontSize:'25px'}}>Your Investments</div>
          <div style={{ width:'100%', height: '100px', paddingTop: '15px', flex: '1' }}>
            {status && <p>{status}</p>}
            <div className="tableContainer">              
              <table className="table">
                <thead>
                  <tr style={{ backgroundColor: '#8cb753', color: '#3a4b00', position:'relative', zIndex:2 }}>
                    <th></th>
                    <th style={{ textAlign: 'left' }}>Symbol</th>
                    <th>Buy Date</th>
                    <th>Buy Price</th>
                    <th>Amount</th>
                    <th>Sell Date</th>                    
                    <th>Sell Price</th>
                    <th>ROI</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody style={{fontSize:'12pt'}}>
                  {enhancedInvestments.length > 0 && enhancedInvestments.map((investment) => (
                    <tr key={investment.invest_id} onClick={() => handleSelectedRow(investment.invest_id, investment)} className={investment.invest_id === selectedFollowId ? 'selectedRow' : ''}>
                      <td>
                        <img src={investment.symbolIcon} alt="" style={{ width: '30px', borderRadius: '50%' }} />
                      </td>
                      <td style={{ ...cellStyle, textAlign: 'left', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '5ch' }}>
                        {investment.symbol.slice(0, -4)}
                      </td>
                      <td style={{ ...cellStyle, color:'#0ef80b' }}>{investment.dateInvest}</td>
                      <td style={{ ...cellStyle, color:'#0ef80b' }}>{investment.invest_value}</td>
                      <td style={{ ...cellStyle, color:investment.isOpen ? '#908f8f94' : 'grey' }}>${investment.ammount}</td>
                      <td style={{ ...cellStyle, color:investment.isOpen ? '#908f8f94' : '#ff2bc5' }}>{investment.close_date}</td>                      
                      <td style={{ ...cellStyle, color:investment.isOpen ? '#908f8f94' : '#ff2bc5' }}>{investment.close_value}</td>                      
                      <td style={{ ...cellStyle, color: investment.isPositive ? investment.isOpen ? '#72f27296' : '#72f272' : investment.isOpen ? '#f29a9a96' : '#f29a9a' , }}>{`$${investment.returnAmtProfit} (${investment.roi})`}% </td>
                      <td style={{ ...cellStyle }} onClick={(event) => event.stopPropagation()}><div onClick={()=>handleCloseOperation(investment)} className={`${investment.isOpen ? 'inves_button_open_close' : 'inves_button_close'}`}>{investment.isOpen ? '' : 'Closed'}</div></td>
                    </tr>
                  ))}
                  {enhancedInvestments.length === 0 &&
                    <tr>
                      <td colSpan={9} style={{ width: '10%', fontSize: '15pt' }}>No data yet, your investments will be listed here.</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
          <div className="button_wrapper_follow" style={{ marginTop: 'auto' }}>            
            <div
              className={`button_container_fw button_delete ${!canDelete ? 'disable_button_follow' : ''}`}
              onClick={canDelete ? handleShow : undefined} >
              <i className="bi bi-trash-fill" style={{ marginRight: '5px' }}></i>
              Remove Ivestment
            </div>  
          </div>          
        </div>     
      <DecisionModal
        show={modalShow}
        onHide={handleClose}
        onConfirm={deleteStrategy}
        title={`Deleting ${selectedInvestment?.symbol} follow up`}
        spin={spin}
        actionConcluded={actionStatus}
      />

      <DecisionModal
        show={statusModalShow}
        onHide={handleClose}
        onConfirm={closeOperation}
        title={`Close the operation for ${selectedInvestment?.symbol}`}
        spin={spin}
        actionConcluded={actionStatus}
      />
    </>
  );
};

export default MyInvestments;